import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { openNotification } from "src/components/helpers/notification"
import ax from "src/store/config"

const initialState = {
  lockersList: null,
  lockersListLoading: false,
  lockerActionsList: null,
  lockerActionsListLoading: false,
  lockerRentsList: null,
  lockerRentsListLoading: false,
}

const url = "/api/admin/directory/lockers"

export const lockersAction = createAsyncThunk(
  "lockersAction",
  async (payload, { dispatch }) => {
    dispatch(setLockersListLoading(true))
    try {
      let data
      switch (payload.flag) {
        case "get":
          ;({ data } = await ax.get(url, { params: payload.value }))
          dispatch(setLockersListLoading(false))
          return data
        case "post":
          ;({ data } = await ax.post(url, payload.value))
          data &&
            openNotification({
              type: "success",
              message: "Шкафчик успешно отредактирован",
            })
          dispatch(setLockersListLoading(false))
          return data
        case "put":
          ;({ data } = await ax.put(url, payload.value))
          data &&
            openNotification({
              type: "success",
              message: "Шкафчик успешно добавлен",
            })
          dispatch(setLockersListLoading(false))
          return data
        case "delete":
          ;({ data } = await ax.delete(url, { params: payload.value }))
          data &&
            openNotification({
              type: "success",
              message: "Шкафчик успешно удален",
            })
          dispatch(setLockersListLoading(false))
          return data
        default:
          dispatch(setLockersListLoading(false))
          break
      }
    } catch (error) {
      dispatch(setLockersListLoading(false))
      openNotification({
        type: "error",
        message: `Ошибка ${error.response?.data?.errorMessages?.[0]?.errorCode || ""}. ${error.response?.data?.errorMessages?.[0]?.errorMessage || "Не удалось выполнить операцию"}`,
      })
      return error
    }
  },
)

export const getLockerActions = createAsyncThunk(
  "getLockerActions",
  async (payload, { dispatch }) => {
    dispatch(setLockerActionsListLoading(true))
    try {
      const { data } = await ax.get("/api/admin/directory/lockerActions", {
        params: payload,
      })
      dispatch(setLockerActionsListLoading(false))
      return data
    } catch (error) {
      dispatch(setLockerActionsListLoading(false))
      openNotification({
        type: "error",
        message: `Ошибка ${error.response?.data?.errorMessages?.[0]?.errorCode || ""}. ${error.response?.data?.errorMessages?.[0]?.errorMessage || "Не удалось загрузить журнал"}`,
      })
    }
  },
)

const rentsUrl = "/api/admin/directory/lockerRents"

export const getLockerRents = createAsyncThunk(
  "getLockerRents",
  async (payload, { dispatch }) => {
    dispatch(setLockerRentsListLoading(true))
    try {
      const { data } = await ax.get(rentsUrl, { params: payload })
      dispatch(setLockerRentsListLoading(false))
      return data
    } catch (error) {
      dispatch(setLockerRentsListLoading(false))
      openNotification({
        type: "error",
        message: `Ошибка ${error.response?.data?.errorMessages?.[0]?.errorCode || ""}. ${error.response?.data?.errorMessages?.[0]?.errorMessage || "Не удалось загрузить аренды"}`,
      })
    }
  },
)

export const getLockerRent = createAsyncThunk("getLockerRent", async (id) => {
  try {
    const { data } = await ax.get(`${rentsUrl}/${id}`)
    return data
  } catch (error) {
    openNotification({
      type: "error",
      message: `Ошибка ${error.response?.data?.errorMessages?.[0]?.errorCode || ""}. ${error.response?.data?.errorMessages?.[0]?.errorMessage || "Не удалось загрузить аренду"}`,
    })
    return error
  }
})

export const cancelLockerRent = createAsyncThunk(
  "cancelLockerRent",
  async (id) => {
    try {
      const { data } = await ax.delete(rentsUrl, { params: { id } })
      openNotification({
        type: "success",
        message: "Аренда отменена",
      })
      return data ?? true
    } catch (error) {
      openNotification({
        type: "error",
        message: `Ошибка ${error.response?.data?.errorMessages?.[0]?.errorCode || ""}. ${error.response?.data?.errorMessages?.[0]?.errorMessage || "Не удалось отменить аренду"}`,
      })
      return error
    }
  },
)

const LockersSlice = createSlice({
  name: "lockers",
  initialState,
  reducers: {
    setLockersListLoading: (state, action) => {
      state.lockersListLoading = action.payload
    },
    setLockerActionsListLoading: (state, action) => {
      state.lockerActionsListLoading = action.payload
    },
    setLockerRentsListLoading: (state, action) => {
      state.lockerRentsListLoading = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(lockersAction.fulfilled, (state, action) => {
      if (action.meta.arg?.flag === "get") {
        state.lockersList = action.payload
      }
    })
    builder.addCase(getLockerActions.fulfilled, (state, action) => {
      state.lockerActionsList = action.payload
    })
    builder.addCase(getLockerRents.fulfilled, (state, action) => {
      if (action.payload) state.lockerRentsList = action.payload
    })
  },
})

export const {
  setLockersListLoading,
  setLockerActionsListLoading,
  setLockerRentsListLoading,
} = LockersSlice.actions

export default LockersSlice.reducer
